/**
 * Auth Entry Point
 *
 * Mounts auth forms (login, register, lost password) for guests.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShopProvider } from '@/context';
import { AuthContainer } from '@/components/Auth';

const container = document.getElementById('evcs-auth');

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ShopProvider>
        <AuthContainer />
      </ShopProvider>
    </StrictMode>
  );
}
